import { Inject, Injectable, Injector } from '@angular/core'; // Import Injector
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '@/services/auth-service/auth.service';
import { environment } from '../../environments/default/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalHttpInterceptorService implements HttpInterceptor {
  
  constructor(
    private injector: Injector, 
    private _loading: LoadingService, 
    @Inject(DOCUMENT) private document: Document
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);
    const router = this.injector.get(Router);
    
    let modifiedReq = req.clone();

    const token = authService.getAccessToken();
    const isApiUrl = req.url.startsWith(environment.mpiBaseUrl) || req.url.startsWith(environment.authBaseUrl);
    const isAnonymousEndpoint =
      req.url.includes('/anonymous/') ||
      req.url.includes('/login') ||
      req.url.includes('/register') ||
      req.url.includes('/refresh') ||
      req.url.includes('/forgot-password') ||
      req.url.includes('/reset-forgot-password');

    if (token && isApiUrl && !isAnonymousEndpoint) {
      modifiedReq = modifiedReq.clone({
        headers: modifiedReq.headers.set('Authorization', `Bearer ${token}`),
      });
    }

    modifiedReq = modifiedReq.clone({
      headers: modifiedReq.headers.set('user-language', this.document.documentElement.lang),
    });

    this._loading.setLoading(true, modifiedReq.url);

    return next.handle(modifiedReq).pipe(
      catchError((error) => {
        this._loading.setLoading(false, modifiedReq.url);
        let handled: boolean = false;
        if (error instanceof HttpErrorResponse) {
          if (!(error.error instanceof ErrorEvent)) {
            switch (error.status) {
              case 401:
                if (!modifiedReq.url.includes('/refresh')) {
                  authService.logout(); 
                  handled = true;
                } else {
                  handled = false;
                }
                break;
              case 403:
                router.navigate(['/invalid-link'], { queryParams: { reason: 'forbidden' } }); 
                handled = true;
                break;
              case 404:
                handled = false;
                break;
              default:
                handled = false;
                break;
            }
          }
        }

        this._loading.setLoading(false, modifiedReq.url);

        if (handled) {
          return of();
        } else {
          return throwError(() => error);
        }
      }),
      map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse) {
          this._loading.setLoading(false, modifiedReq.url);
        }
        return evt;
      })
    );
  }
}